export const DEMO_CLUSTER_ID = '11111111-1111-1111-1111-111111111111';

/** Primary cluster id in OP demo fixtures (`libs/fixtures/src/fixtures/op-demo/static/clusters.getClusters.json`). */
export const OP_DEMO_FIXTURE_CLUSTER_ID =
  'ca0cdb62-7e1b-45f3-94bf-fe0f8b187954';

export const isDemoCluster = (id: string): boolean => {
  return id === DEMO_CLUSTER_ID;
};

/** Synthetic clusters that should use classic-style demo placeholders (classic + OP demo fixture). */
export const isSimulatedDemoClusterId = (id: string): boolean =>
  isDemoCluster(id) || id === OP_DEMO_FIXTURE_CLUSTER_ID;
